// Get Environment

const ENV_CONFIG = {
  dev: {
    BASE_URL: process.env.REACT_APP_BASE_URL_DEV,
  },
  staging: {
    BASE_URL: process.env.REACT_APP_BASE_URL_STAGING,
  },
  preprod: {
    BASE_URL: process.env.REACT_APP_BASE_URL_PREPROD,
  },
  production: {
    BASE_URL: process.env.REACT_APP_BASE_URL_PROD,
  },
};

const getEnvironment = () => {
  const server = process.env.REACT_APP_SERVER;

  if (!server) {
    throw new Error("Environment variables is not defined!");
  }

  return ENV_CONFIG[server];
};

export const REPORTS_API_URL = process.env.REACT_APP_REPORTS_API_URL;
export const DSA_API_URL = process.env.REACT_APP_DSA_API_URL;
export const DSA_X_API_KEY = process.env.REACT_APP_DSA_X_API_KEY;
export const DSA_X_API_SECRET = process.env.REACT_APP_DSA_X_API_SECRET;
export const LENTRA_API_URL = process.env.REACT_APP_LENTRA_API_URL;
export const LENTRA_API_KEY_B64 = process.env.REACT_APP_LENTRA_API_KEY_B64;
export const LENTRA_API_SECRET_B64 = process.env.REACT_APP_LENTRA_API_SECRET_B64;

export { getEnvironment };
